var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.role === 'guest')?_c('v-card',{attrs:{"elevation":"8"}},[_c('v-card-title',[_vm._v("Accesso non consentito")]),_c('v-card-text',[_vm._v(" L'accesso è riservato agli studenti dei corsi di laurea di area informatica ed ai docenti relatori di tesi di area informatica. ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }